var currentQuote = JSON.parse(localStorage.getItem('currentQuote'))

export const app = {
  namespaced: true,
  state: {
    quote: currentQuote
  },
  actions: {
    setQuote ({commit}, quote) {
      commit('setQuote', quote)
    },
    addItem ({commit}, item) {
      commit('addItem', item)
    },
    removeItem ({commit}, index) {
      commit('removeItem', index)
    },
    updateQuantity ({commit}, { index, quantity }) {
      commit('updateQuantity', { index, quantity })
    },
    updateTitle ({commit}, title) {
      commit('updateTitle', title)
    },
    deleteQuote ({commit}) {
      commit('deleteQuote')
    }
  },
  mutations: {
    setQuote (state, quote) {
      state.quote = quote
      localStorage.setItem('currentQuote', JSON.stringify(state.quote))
    },
    addItem (state, item) {
      state.quote.items.push(item)
      localStorage.setItem('currentQuote', JSON.stringify(state.quote))
    },
    removeItem (state, index) {
      state.quote.items.splice(index, 1)
      localStorage.setItem('currentQuote', JSON.stringify(state.quote))
    },
    updateQuantity (state, { index, quantity }) {
      state.quote.items[index].quantity = quantity
      localStorage.setItem('currentQuote', JSON.stringify(state.quote))
    },
    updateTitle (state, title) {
      state.quote.title = title
      localStorage.setItem('currentQuote', JSON.stringify(state.quote))
    },
    deleteQuote (state) {
      state.quote = null
      localStorage.removeItem('currentQuote')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/app/index.js